import { useParams } from 'react-router-dom';
import { ApiMeetRepository } from '../../../features/Meet';
import { FeedbackPage } from './Feedback';

const meetRepository = new ApiMeetRepository();

export function FeedbackFactory() {
	const { code, tenant } = useParams();

	return (
		<FeedbackPage meetRepository={meetRepository} code={code} tenant={tenant}/>
	);
}
